/**
 * @TODO Implement native solution when it will land.
 *
 * @see https://addyosmani.com/blog/lazy-loading/
 * @see https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video/
 */
import lazysizes from 'lazysizes';

/**
 * Notify lazysizes that the data-src was updated
 *
 * @see {@link https://github.com/aFarkas/lazysizes/issues/46|notify lazysizes}
 *
 * @param {DOMString} selectors A DOMString containing one or more selectors to match against.
 */
lazysizes.notifyUpdate = (selectors) => {
    const elements = document.querySelectorAll(selectors);

    if (!elements) {
        return;
    }

    Array.from(elements).forEach((elm) => {
        if (elm.classList.contains('lazyloaded')) {
            elm.classList.remove('lazyloaded');
            elm.classList.add('lazyload');
        }
    });
};

export default lazysizes;
